import common from '@/store/common/mutations';
import * as types from './mutation-types';

const selectDate = (state, { from }) => {
	//console.log('fromDateSetting>>>', from);
	//state.searchParams.startDt = from.replace(/\-/g, '');
	//state.searchParams.endDt = to.replace(/\-/g, '');
	state.searchParams.strtDt = from;

	// console.log('mutation-selectedDate', state.fromDate, state.toDate);
};

let date = new Date();
let month = parseInt(date.getMonth() + 1);
let day = date.getDate();
if (month < 10) month = '0' + month;
if (day < 10) day = '0' + day;
let currentDate = date.getFullYear() + month + day;
import moment from 'moment';
let today = moment().startOf('month').format('YYYY-MM-DD');

const getInit = () => {
	return {
		searchParams: {
			varId: null,
			varVal: null,
			useYn: null,
			strtDt: today
		},
		variableManagements: [],
		useYnList: [],
		gridUseYnList: [],
		excelDownLoadList: [], //엑셀다운로드시 해더저장
		pagingInfo: {
			currentPage: 1,
			endPage: 1,
			pageUnit: 30,
			startPage: 1,
			totalSize: 1
		}
	};
};

export default {
	...common,
	selectDate,
	[types.STATE_INIT]: state => {
		Object.assign(state, getInit()); //
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	}
};
